import { c as _c } from "react/compiler-runtime";
import { ListingCardShell, ListingCardImage, ListingCardContent, CategoryTags } from "../parts";
import type { VisualType } from "@/lib/types";
export function StoreCard(t0) {
  const $ = _c(22);
  const {
    visual,
    title,
    href,
    district,
    categories,
    className,
    imageSizes,
    imageCropAspect,
    isLogo
  } = t0;
  let t1;
  if ($[0] !== categories) {
    t1 = categories ?? [];
    $[0] = categories;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <CategoryTags categories={t1} max={3} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== imageCropAspect || $[5] !== imageSizes || $[6] !== isLogo || $[7] !== t2 || $[8] !== visual) {
    t3 = <ListingCardImage visual={visual} overlay={t2} sizes={imageSizes} cropAspect={imageCropAspect} isLogo={isLogo} />;
    $[4] = imageCropAspect;
    $[5] = imageSizes;
    $[6] = isLogo;
    $[7] = t2;
    $[8] = visual;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== title) {
    t4 = <p className="w-full typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</p>;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== district) {
    t5 = district && <p className="typography-component-xs-regular text-text-secondary desktop:typography-component-sm-regular">{district}</p>;
    $[12] = district;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <ListingCardContent gapClass="gap-2">{t4}{t5}</ListingCardContent>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== className || $[18] !== href || $[19] !== t3 || $[20] !== t6) {
    t7 = <ListingCardShell href={href} gapClass="gap-3 desktop:gap-4" className={className}>{t3}{t6}</ListingCardShell>;
    $[17] = className;
    $[18] = href;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}